'use strict'
import { request } from '../../plugins/http'

export default async (situations) => {
    return await request.put('/situacaoAtendimento', situations)
}